/* eslint-disable
    no-return-assign,
    radix
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import OwnablesManageView from 'profile/OwnablesManageView';
import * as ladders from 'molbio/virtual-digests/Ladders';
import notifications from 'notifications';
import * as analytics from 'analytics/Analytics';

class LadderContentView extends Backbone.View {
  static initClass() {
    this.prototype.el = '.ladder-bands-view';
    this.prototype.events = {'input .ladder-bands': 'parseBands'};
  }

  initialize() {
    return (this.parsedBands = []);
  }

  die() {
    this.stopListening();
    this.undelegateEvents();
  }

  update(ladder) {
    this.parsedBands = ladder.bandSizes();
    this.$('.ladder-bands')
      .val(this.parsedBands.join('\n'))
      .attr({disabled: !ladder.get('permissions').writable});
    return this.updatePreview();
  }

  parseBands(e) {
    const bandText = $(e.currentTarget).val().split('\n');
    this.parsedBands = (() => {
      const result = [];
      for (const text of Array.from(bandText)) {
        const parsed = parseInt(text);
        if (Number.isNaN(parsed)) {
          continue;
        }
        result.push(parsed);
      }
      return result;
    })();
    this.parsedBands.sort((a, b) => b - a);
    return this.updatePreview();
  }

  updatePreview() {
    return this.$('.preview').html(this.parsedBands.join('<br>'));
  }

  bands() {
    return this.parsedBands;
  }
}
LadderContentView.initClass();

let laddersCollection = null;

class LaddersView extends OwnablesManageView {
  static initClass() {
    this.prototype.el = '.js-ladders';
    this.prototype.type = 'ladders';
    this.prototype.modelType = ModelTypeConstants.LADDER;
  }
  events() {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(super.events(), {
      'submit .create-new form': 'createNewLadder',
      'click .save-bands': 'saveBands',
    });
  }

  static getBootstrappedOwnables() {
    if (laddersCollection == null) {
      laddersCollection = new ladders.Collection(window.bootstrap.ladders);
    }
    return laddersCollection;
  }

  initialize(options) {
    this.ladderContent = new LadderContentView();
    return super.initialize(options);
  }

  die() {
    super.die();
    this.ladderContent.die();
  }

  saveBands(e) {
    const $target = $(e.currentTarget);
    $target.button('loading');
    return this.currentOwnable
      .save(
        {band_sizes: this.ladderContent.bands()},
        {patch: true, url: `${this.currentOwnable.url()}/attributes`}
      )
      .fail(notifications.notifyError)
      .done(() => {
        notifications.success('Ladder successfully saved.');
        return $target.button('reset');
      });
  }

  createNewLadder(e) {
    e.preventDefault();
    const ladder = new ladders.Model({
      name: this.$el.find('.create-new .name').val(),
      description: this.$el.find('.create-new .description').val(),
      owner_id: window.bootstrap.current_entity_id,
    });
    return ladder
      .save()
      .fail(notifications.notifyError)
      .done(() => {
        this.$el.find('.create-new .name, .create-new .description').val('');
        this.ownables.add(ladder);
        this.navigateToOwnable(ladder.id);
        notifications.success('Ladder created successfully!');
        return analytics.track('DATA_MANAGEMENT', 'created_ownable', {
          type: this.type,
          name: ladder.get('name'),
          has_description: ladder.get('description').length > 0,
        });
      });
  }

  renderOwnable() {
    super.renderOwnable();
    const list = this.currentOwnable;
    this.ladderContent.update(list);
    const {writable} = list.get('permissions');
    this.$('.writable-instructions, .save-bands').toggleClass('hidden', !writable);
    this.$('.readable-instructions').toggleClass('hidden', writable);
    $.getJSON(`/1/api/ladders/${list.id}/collaborators/`)
      .done((res) => this.createCollaboratorsView(res))
      .fail(notifications.notifyError);
  }
}
LaddersView.initClass();

export default LaddersView;
